module.exports = __webpack_public_path__ + "assets/HomeMarker-old-a1ad1f.svg";